import { isString } from 'lodash';

export function hasContainsIgnoreCase(value: string, searchString: string, position?: number): boolean {
    return value?.toLowerCase().includes(searchString?.toLowerCase(), position);
}

export function localeCompare(value: string, compareValue: string): number {
    return value?.localeCompare(compareValue);
}

export function toArrayStrings(value: string | string[]): string[] {
    if (!value) {
        return [];
    }
    return isString(value) ? [value] : value;
}
export function convertToString(value: string | Array<string> | null): string {
    if (!value) {
        return '';
    }
    if (Array.isArray(value)) {
        return value.join(', ');
    }
    return value.toString();
}